/**
 * Steps of the candidate journey (Kandidatenreise) – how our hiring process works for candidates.
 */
export const CANDIDATE_JOURNEY_STEPS = [
  {
    step: 1,
    title: "Erster Kontakt",
    subtitle: "Kennenlernen auf Augenhöhe",
    description:
      "Ob Sie von uns angesprochen werden oder sich initiativ bei uns melden – wir starten mit einem unverbindlichen Gespräch. Dabei geht es um Ihre berufliche Situation, Ihre Ziele und Wünsche. So verstehen wir Ihr Profil und können Sie nur mit wirklich passenden Möglichkeiten ansprechen.",
  },
  {
    step: 2,
    title: "Profil & Bedarfsklärung",
    subtitle: "Transparenz von Anfang an",
    description:
      "Wir klären gemeinsam Ihre Stärken, Rahmenbedingungen und Präferenzen. Sie erfahren, wie wir arbeiten, welche Mandate wir betreuen und wie Diskretion und Datenschutz gewährleistet werden. Es entstehen keine Kosten für Sie – unsere Leistung trägt der Arbeitgeber.",
  },
  {
    step: 3,
    title: "Passende Mandate",
    subtitle: "Nur relevante Vorschläge",
    description:
      "Sobald eine Position zu Ihrem Profil passt, stellen wir Ihnen den Arbeitgeber und die Rolle vor. Sie entscheiden, ob Sie sich vorstellen möchten. Ohne Ihr Einverständnis geben wir keine Daten weiter. So behalten Sie die Kontrolle und vermeiden unerwünschte Kontakte.",
  },
  {
    step: 4,
    title: "Vorstellungsgespräche & Begleitung",
    subtitle: "An Ihrer Seite",
    description:
      "Bei Interesse vermitteln wir den Kontakt zum Arbeitgeber und begleiten Sie durch Terminabsprachen, Vorstellungsgespräche und – bei Bedarf – durch die Vertragsverhandlung. Wir sind Ansprechpartner für beide Seiten und sorgen für einen fairen, zügigen Ablauf.",
  },
  {
    step: 5,
    title: "Vertragsangebot & Einstieg",
    subtitle: "Der nächste Karriereschritt",
    description:
      "Nach Ihrer Entscheidung unterstützen wir bei der Klärung offener Fragen und dem reibungslosen Einstieg. Unser Ziel ist eine langfristig erfolgreiche Zusammenarbeit zwischen Ihnen und dem Arbeitgeber – und wir bleiben auch danach ein vertrauensvoller Ansprechpartner.",
  },
];
